import MetricDetailTable from './MetricDetailTable';

export default MetricDetailTable;
